import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";
import { ShareLinkedIn, ShareTwitter } from "../Share";
import isBrowserEnv from "../../utils/isBrowserEnv";

import ActionButton from "../ActionButton";

const FigureFooter = ({
  onDownloadClick,
  note,
  sources,
  title,
  chartId,
  groupId
}) => {
  let here;
  let imagePath;
  let linkedinText = title;
  let twitterText = title;
  if (isBrowserEnv() && window.location.href) {
    here = window.location.href;
    imagePath = `${window.location.origin}/chart/state-of-european-tech-2017-${
      chartId
    }-${groupId}.jpg`;
    twitterText = `${title} ${imagePath}`;
  }
  return (
    <div className={styles.root}>
      {onDownloadClick && (
        <div className={styles.section}>
          <div className={styles.button}>
            <ActionButton onClick={onDownloadClick} />
          </div>
          <div className={styles.social}>
            <div className={styles.socialAction}>
              <ShareLinkedIn
                url={here}
                sourceUrl={imagePath}
                title={linkedinText}
                image={imagePath}
              />
            </div>
            <div className={styles.socialAction}>
              <ShareTwitter text={twitterText} />
            </div>
          </div>
        </div>
      )}
      {note && (
        <dl className={styles.list}>
          <dt className={styles.term}>Note:</dt>
          <dd className={styles.definition}>{note}</dd>
        </dl>
      )}
      {sources && (
        <dl className={styles.list}>
          <dt className={styles.term}>Source:</dt>
          <dd className={styles.definition}>{sources}</dd>
        </dl>
      )}
    </div>
  );
};

FigureFooter.propTypes = {
  insight: PropTypes.string,
  note: PropTypes.string,
  onDownloadClick: PropTypes.func,
  sources: PropTypes.string,
  title: PropTypes.string,
  chartId: PropTypes.number,
  groupId: PropTypes.number
};

export default FigureFooter;



// WEBPACK FOOTER //
// ./src/components/FigureFooter/index.js